export default "__VITE_ASSET__80b74861__"